import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Search } from 'assets/images/search_icon.svg';
import Button from 'components/Buttons/Button';
import CheckboxComponent from 'components/Checkbox';

interface FieldProps {
  colstart: number;
  colend: number;
  rowstart: number;
  rowend: number;
}

export const TravelKindRowContainer: any = styled.section`
  display: flex;
  justify-content: flex-start;
`;

TravelKindRowContainer.CheckboxContainer = styled.div`
  display: flex;
  margin-right: 15px;
  margin-top: 5px;

  & > span {
    margin-left: 8px;
    color: ${({ theme }) => theme.flightSearch.kindLabel};
  }
`;

TravelKindRowContainer.label = styled.span`
  font-size: 12px;
`;

export const Container = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05);
  padding: 10px;
  border-radius: 10px;
  border-top-left-radius: 0;
  background: ${ColorPalette.HEX.White};
`;

export const Fields = styled.div`
  display: grid;
  grid-template-columns: repeat(32, 1fr) 58px;
  column-gap: 8px;
  row-gap: 8px;
  width: 100%;
  margin: 0 auto;
`;

export const Field = styled.div<FieldProps>`
  grid-column-start: ${({ colstart }) => colstart};
  grid-column-end: ${({ colend }) => colend};
  grid-row-start: ${({ rowstart }) => rowstart};
  grid-row-end: ${({ rowend }) => rowend};
`;

export const RoundTripIcon = styled.span`
  font-size: 25px;

  & > svg {
    display: block;

    &:last-child {
      margin-top: -15px;
    }
  }
`;

export const SearchButton = styled(Button)`
  height: 56px;
  font-size: 16px;
  padding: 0;
  background: ${({ theme }) => theme.button.background};
  &:disabled {
    opacity: 0.1;
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  cursor: pointer;
  margin-top: 5px;
  align-items: flex-start;
  & > span {
    border-radius: 4px;
  }
`;

export const BaggageIncluded = styled.h5`
  padding-left: 15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.flightSearch.baggage};
`;

interface IconProps {
  $size?: number;
}
export const Icon = styled.div<IconProps>`
  color: ${ColorPalette.HEX.PineTree};
  width: ${({ $size }) => ($size ? `${$size}px` : '21px')};
  height: ${({ $size }) => ($size ? `${$size}px` : '21px')};
`;

export const IconSearch = styled(Search)`
  width: 28px;
  height: 28px;
`;

export const Sector = styled.span`
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  height: 100%;
`;

export const AddAndRemoveSectorContainer = styled.div`
  text-align: right;
`;
export const AddAndRemoveSector = styled.a`
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 15px;
  color: #706967;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandIcon = styled.svg`
  path {
    stroke: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;

export const ExpandSectors = styled.a`
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 15px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
